/** Métodos de ayuda para trabajar con cadenas de texto. */
export class StringHelper {


    /** Conprueba si el texto proporcionado contiene una cadena vacía o es nulo|undefined */
    static isNullOrEmpty(text: string | null | undefined){
        return text === undefined || text === null || text === '';
    }

}